import { useLocation } from "react-router-dom";
import { Badge, Flex, Text, Visible } from "../../components";
import { PhoneFilled, ShoppingFilled } from "@ant-design/icons";
import { useApp, useNavigate, useSearchParams } from "../../hooks";
import { useCartStore } from "../../stores";
import { useEffect } from "react";
import { twMerge } from "tailwind-merge";
import TimeBanner from "../timeBanner";
import UserRegion from "./userRegion";
import { Images } from "../../assets";
import { Tools } from "../../utils";
import UserInfo from "./userInfo";
import Cart from "../cart";

const Header = () => {
  const totalItemsInCart = useCartStore((state) => state.totalItemsInCart);
  const { logoUrl, bootstrap } = useApp();
  const { setSearchParams } = useSearchParams({ cart: false });
  const { navigate } = useNavigate();
  const location = useLocation();
  const phoneSocial = bootstrap?.socials?.find(
    (link) =>
      link.type === "phone" ||
      link.platform === "phone" ||
      String(link.url || "").startsWith("tel:"),
  );
  const phone = Tools.asText(
    bootstrap?.contact?.uanNumber ||
      phoneSocial?.value ||
      phoneSocial?.url,
  ).replace(/^tel:/i, "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const renderLogo = () => (
    <img
      alt={bootstrap?.contact?.restaurantName || "logo"}
      src={Tools.mediaUrl(logoUrl) || Images.logo}
      className="h-auto w-[7rem] cursor-pointer object-contain"
      onClick={() => navigate("/")}
    />
  );

  return (
    <>
      <TimeBanner />
      <div
        className={twMerge(
          "storefront-header relative z-[1] bg-primary pt-[1.2rem] pb-[1.2rem] text-on-secondary shadow-card",
          location.pathname === "/" && "rounded-b-[3.2rem] pb-[3rem]",
        )}
      >
        <div className="px-page">
          <div className="flex min-h-[8rem] items-center justify-between mobile:grid mobile:grid-cols-[1fr_auto_1fr]">
            <Flex className="h-100 min-w-0" align="center" gap={"2rem"}>
              <span className="mobile:hidden">{renderLogo()}</span>
              {location.pathname !== "/checkout" && (
                <Visible mobile={false} children={<UserRegion />} />
              )}
              {!!phone && (
                <Flex
                  gap={".6rem"}
                  align="center"
                  className="cursor-pointer ml-[1rem]"
                  onClick={() => window.open(`tel:${phone.replace(/\s/g, "")}`)}
                >
                  <PhoneFilled style={{ fontSize: "2.2rem" }} />
                  <Text
                    level={5}
                    weight={"700"}
                    type={"tertiary"}
                    children={phone}
                    className="d-none-mobile"
                  />
                </Flex>
              )}
            </Flex>
            <Visible mobile children={renderLogo()} />
            <Flex align="center" justify="flex-end" gap={"3rem"}>
              <Visible mobile children={<UserInfo type="drawer" />} />
              <Visible mobile={false} children={<UserInfo />} />
              <Visible mobile={false}>
                {location.pathname === "/checkout" ? (
                  <div />
                ) : (
                  <Badge
                    count={totalItemsInCart}
                    color="accent"
                    onClick={() => setSearchParams({ cart: true })}
                  >
                    <ShoppingFilled
                      className="cursor-pointer"
                      style={{ fontSize: "3rem" }}
                    />
                  </Badge>
                )}
              </Visible>
            </Flex>
          </div>
          {location.pathname !== "/checkout" && (
            <Visible mobile>
              <Flex
                align="center"
                justify="center"
                className="h-[5rem] w-full"
                children={<UserRegion className="inline-flex items-center" />}
              />
            </Visible>
          )}
          <Cart />
        </div>
      </div>
    </>
  );
};

export default Header;
